'use client';

import { InView } from 'react-intersection-observer';
import { CSSProperties, JSX } from 'react';

interface CustomInViewProps {
  classes?: string;
  triggerOnce?: boolean;
  as?: keyof JSX.IntrinsicElements,
  children: React.ReactNode;
  extraStyles?: CSSProperties;
}

function CustomInView({
  classes = '', triggerOnce = true, as = 'div', children, extraStyles,
}: CustomInViewProps) {
  return (
    <InView as={as} style={extraStyles} triggerOnce={triggerOnce} className={classes} onChange={(inView, entry) => (inView ? entry.target.classList.add('inView') : (triggerOnce ? null : entry.target.classList.remove('inView')))}>
      {children}
    </InView>
  );
}

export default CustomInView;
